<template>
  <div class="hHP flex directionColumn marginLeft10 marginRight10">
    <div class="padding10 border borderRadius10 marginBottom10">
      <div class="fs13">{{ storeInfo.cname }}</div>
      <a class="purple fs13">{{ storeInfo.caddr }}</a>
    </div>
    <div class="padding10 border borderRadius10 marginBottom10 hHP">
      <div class="borderBottom" style="padding-bottom: 5px; margin-bottom: 5px">
        <span class="fs20">门店监控</span>
      </div>
      <el-row>
        <el-col v-for="item in deviceList" :key="item.id" :span="8" style="text-align: center;">
          <svg  @click="openVideo(item)" style="cursor: pointer;" t="1730201674113" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18274" width="64" height="64"><path d="M512 618.3936a174.08 174.08 0 1 1 174.7968-174.08 174.08 174.08 0 0 1-174.7968 174.08z m-58.2656-174.08a57.9584 57.9584 0 1 0-58.2656-58.0608 58.2656 58.2656 0 0 0 58.2656 58.0608z m-19.456 309.4528h155.4432v116.0192H434.2784zM298.2912 869.7856h427.4176a38.7072 38.7072 0 1 1 0 77.4144H298.2912a38.7072 38.7072 0 1 1 0-77.4144z m0 0" p-id="18275"></path><path d="M512 734.4128a290.9184 290.9184 0 1 0-206.0288-84.992A290.7136 290.7136 0 0 0 512 734.4128z m0 77.4144A367.4112 367.4112 0 0 1 250.9824 184.32 368.64 368.64 0 1 1 512 811.8272z m0 0" p-id="18276"></path></svg>
        </el-col>
      </el-row>
    </div>
    <div class="padding10 border borderRadius10">
      <div class="borderBottom" style="padding-bottom: 5px; margin-bottom: 5px">
        <span class="fs20"> 门店智控</span>
      </div>
      <el-row class="padding10">
        <el-col :span="8">
          <el-button type="primary" size="mini" :loading="doorOpenLoading" style="width:90px;" @click="handleDoorOpen">门禁开</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="success" size="mini" style="width:90px;" :loading="lightOpenLoading" @click="handleLightOpen">灯光开</el-button>
        </el-col>
        <el-col :span="8">
          <el-button size="mini" style="width:90px;" :loading="lightCloseLoading" @click="handleLightClose">灯光关</el-button>
        </el-col><br><br>
        <el-col :span="8">
          <el-button type="primary" size="mini" style="width:90px;" :loading="arrvLoading" @click="activateInStore">到店模式</el-button>
        </el-col>
      </el-row>
      <a href="#" class="adding10" style="color: #b5b4bf">更多控制</a>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "OrderGoodsAdd",
  props: {
    storeInfo: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      deviceInfo: {status: 1},
      // 智控按钮禁用状态
      doorOpenLoading: false,
      doorCloseLoading: false,
      lightOpenLoading: false,
      lightCloseLoading: false,
      deviceRefreshLoading: false,
      arrvLoading: false,
      deviceList: [{
        id: 1,
        pos: 1,
      },{
        id: 2,
        pos: 2,
      }],
      nickName: store.getters.nickName,
    };
  },
  methods: {
    openVideo(item) {
      const url = `/components/videoWindows?deviceId=${item.code}&channelId=0&pwd=${item.password}&storeName=${this.storeInfo.cname}&deviceName=${item.name}`;
      // 打开新标签页
      window.open(url, "_blank");
    },
    activateInStore() {
      this.arrvLoading = true
      let url = `${this.baseUrls.iot}/activateInStore`;
      this.topsAjax.get(url, { storeId: this.storeInfo.sid }).then((res) => {
        this.arrvLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleDoorOpen() {
      this.doorOpenLoading = true
      this.topsAjax.post(`${this.baseUrls.iot}/openOrClose`, { storeId: this.storeInfo.sid, system: "tops-service", opera: this.nickName, type: "DOOR", openOrClose: 1 }).then(() => {
        this.doorOpenLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      }).catch(e => {
        this.doorOpenLoading = false
      });
    },
    handleLightOpen() {
      this.lightOpenLoading = true
      let url = `${this.baseUrls.iot}/openOrCloseLight`
      this.topsAjax.post(`${this.baseUrls.iot}/openOrClose`, { storeId: this.storeInfo.sid, system: "tops-service", opera: this.nickName, type: "LIGHT", openOrClose: 1 }).then(() => {
        this.lightOpenLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleLightClose() {
      this.lightCloseLoading = true
      this.topsAjax.post(`${this.baseUrls.iot}/openOrClose`, { storeId: this.storeInfo.sid, system: "tops-service", opera: this.nickName, type: "LIGHT", openOrClose: 0 }).then(() => {
        this.lightCloseLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleDeviceRefresh() {
      this.deviceRefreshLoading = true
      let url = `${this.baseUrls.iot}/uploadData`
      this.topsAjax.get(url, { devUid: this.deviceInfo.code, type: this.deviceInfo.type }).then(() => {
        this.deviceRefreshLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.topsAjax.get(`${this.baseUrls.iot}/queryDevice?storeId=${this.storeInfo.sid}`).then((response) => {
          this.deviceInfo = response
        });
      });
    },
  }
};
</script>

<style lang="scss">
.newOrderGoodsAdd {
  height: 600px;
  background-color: white;
  display: flex;
  flex-direction: column;



  .el-tabs__item {
    padding: 0 10px;
  }

  .el-tabs__item.is-active {
    text-decoration: underline;
  }


  .el-popper[x-placement^="bottom"] {
    margin-left: -40px;
  }
}

//.orderGoodsAdd {
//  height: 500px;
//  background-color: white;
//  display: flex;
//  flex-direction: column;
//
//  &__top {
//    flex: 1;
//  }
//
//  &__bottom {
//    height: 50px;
//    line-height: 50px;
//    text-align: right;
//  }
//
//  .el-input {
//    width: 120px;
//  }
//
//  .cell {
//    & > div {
//      width: 120px;
//    }
//  }
//}
</style>
